export const calculateDelay = (id: number) => {
  if (id === 0) {
    return 0
  } else return id * 0.3
}
